import baseApi from './base.api'

interface dashboardFilters {
  departments?: string[]
  roles?: string[]
  units?: string[]
  contents?: string[]
  users?: string[]
  dateRange?: string[]
}

// Filtros comuns utilizados no dashboard
const genFiltersParams = (filters?: dashboardFilters) => {
  filters = filters || {}

  const resFilter = {
    DepartamentoIds: filters.departments?.length > 0 ? filters.departments : null,
    CargoIds: filters.roles?.length > 0 ? filters.roles : null,
    UnidadeDeNegocioIds: filters.units?.length > 0 ? filters.units : null,
    ConteudoIds: filters.contents?.length > 0 ? filters.contents : null,
    UsuariosIds: filters.users?.length > 0 ? filters.users : null,
    DataInicio: filters.dateRange?.[0] ? (new Date(filters.dateRange?.[0])).toISOString().split('T')[0] : '',
    DataFim: filters.dateRange?.[1] ? (new Date(filters.dateRange?.[1])).toISOString().split('T')[0] : ''
  }

  if (!resFilter.DataInicio) delete resFilter.DataInicio
  if (!resFilter.DataFim) delete resFilter.DataFim

  return resFilter
}

const api = {
  ...baseApi,
  async getManagerData(filters?: dashboardFilters) {
    const { success, data } = await api.setResource('DashboardGestor').post('', genFiltersParams(filters))

    return {
      success,
      data: {
        subscriptions: {
          total: data?.inscricoes?.total || 0 as number,
          complete: data?.inscricoes?.concluido || 0 as number,
          completePercent: data?.inscricoes?.percentualConcluido || 0 as number,
          onGoing: data?.inscricoes?.emAndamento || 0 as number,
          onGoingPercent: data?.inscricoes?.percentualEmAndamento || 0 as number,
          notStarted: data?.inscricoes?.naoIniciado || 0 as number,
          notStartedPercent: data?.inscricoes?.percentualNaoIniciado || 0 as number
        },
        contentSubscriptions: {
          data: data?.inscricoesPorConteudo?.conteudos.map(item => ({
            type: item.tipo,
            complete: item.concluido || 0 as number,
            completePercent: item.percentualConcluido || 0 as number,
            onGoing: item.emAndamento || 0 as number,
            onGoingPercent: item.percentualEmAndamento || 0 as number,
            notStarted: item.naoIniciado || 0 as number,
            notStartedPercent: item.percentualNaoIniciado || 0 as number
          }) || []),
          total: data?.inscricoesPorConteudo?.total || 0 as number
        },
        hours: {
          total: data?.horas?.total || 0 as number,
          complete: data?.horas?.concluido || 0 as number,
          completePercent: data?.horas?.percentualConcluido || 0 as number,
          onGoing: data?.horas?.emAndamento || 0 as number,
          onGoingPercent: data?.horas?.percentualEmAndamento || 0 as number,
        },
        users: {
          total: data?.usuarios?.total || 0 as number,
          active: data?.usuarios?.ativos || 0 as number,
          activePercent: data?.usuarios?.percentualAtivos || 0 as number,
          inactive: data?.usuarios?.inativos || 0 as number,
          inactivePercent: data?.usuarios?.percentualInativos || 0 as number
        },
        details: {
          subscriptions: data?.detalhesInscricoes?.map(item => ({
            userId: item.usuarioId,
            userStatus: item.ativo ? 'Ativo' : 'Inativo',
            userName: item.nomeDoAluno,
            userEmail: item.email,
            userDocument: item.usuarioCpf,
            contentName: item.nomeDoConteudo,
            contentType: item.tipo,
            contentCategory: item.categoria,
            contentPercentage: item.percentualConsumoConteudo,
            subscribedAt: item.dataInscricao,
            completedAt: item.dataConclusao,
            expired: item.expirado,
            status: item.status,
            certificateId: item.certificadoId,
            courseOrFormationId: item.cursoFormacaoId,
            origin: item.origem
          }) || []),
          hours: data?.detalhesHoras?.map(item => ({
            userStatus: item.ativo ? 'Ativo' : 'Inativo',
            userName: item.nomeDoAluno,
            userEmail: item.email,
            hoursTrained: item.horasTreinadas,
            inscriptions: item.inscricoes,
            contentType: item.tipo
          }) || []),
          consumedContent: data?.detalhesConteudosConsumidos?.map(item => ({
            userStatus: item.ativo ? 'Ativo' : 'Inativo',
            userName: item.nomeDoAluno,
            userEmail: item.email,
            contentName: item.nomeDoConteudo,
            contentType: item.tipo,
            startedAt: item.dataInicio,
            completedAt: item.dataConclusao,
            status: item.status,
            contentCategory: item.categoria,
            duration: item.duracao,
            percent: item.percentualConsumoConteudo
          }) || []),
          access: data?.acessos?.detalhes?.map(el => ({
            userStatus: el.ativo ? 'Ativo' : 'Inativo',
            userName: el.aluno,
            qtAccess: el.qtdAcessos,
            lastAccess: el.ultimoAcesso
          }))
        },
        consumedContent: {
          total: data?.conteudosConsumidos?.total || 0 as number,
          complete: data?.conteudosConsumidos?.concluido || 0 as number,
          completePercent: data?.conteudosConsumidos?.percentualConcluido || 0 as number,
          onGoing: data?.conteudosConsumidos?.emAndamento || 0 as number,
          onGoingPercent: data?.conteudosConsumidos?.percentualEmAndamento || 0 as number,
        },
        access: {
          accessPerYear: data?.acessos?.acessosPorAno?.map(year => ({
            year: year.ano,
            total: year.total,
            accessPerMonth: year.acessosPorMes.map(month => ({
              month: month.mes,
              total: month.total
            }))
          })),
          total: data?.acessos?.total || 0
        }
      }
    }
  },

  async getUserData(filters?: dashboardFilters) {
    const { success, data } = await api.setResource('DashboardAluno').post('', genFiltersParams(filters))

    return {
      success,
      data: {
        contentSubscriptions: {
          total: data.inscricoesPorConteudo?.total || 0 as number,
          data: data.inscricoesPorConteudo?.conteudos.map(item => ({
            type: item.tipo,
            complete: item.concluido || 0 as number,
            completePercent: item.percentualConcluido || 0 as number,
            onGoing: item.emAndamento || 0 as number,
            onGoingPercent: item.percentualEmAndamento || 0 as number,
            notStarted: item.naoIniciado || 0 as number,
            notStartedPercent: item.percentualNaoIniciado || 0 as number
          })) || []
        },
        hours: {
          total: data.horas?.total || 0 as number,
          course: data.horas?.curso || 0 as number,
          coursePercentage: data.horas?.percentualCurso || 0 as number,
          formation: data.horas?.formacao || 0 as number,
          formationPercentage: data.horas?.percentualFormacao || 0 as number
        },
        onGoing: data.emAndamento?.map(item => ({
          id: item.id,
          type: item.tipo?.toLowerCase() === 'formação' ? 'Trilha' : item.tipo,
          title: item.titulo,
          cover: item.linkDaImagemDeCapa,
          progress: item.percentualConsumoConteudo,
          src: item.tipo?.toLowerCase() === 'scorm' ? item.scormScriptLink : item.urlDoRecurso
        }) || []),
        details: {
          subscriptions: data.detalhesInscricoes?.map(item => ({
            active: item.ativo,
            name: item.nomeDoConteudo,
            category: item.categoria,
            type: item.tipo,
            progress: item.percentualConsumoConteudo,
            subscribedAt: item.dataInscricao,
            completedAt: item.dataConclusao,
            courseOrFormationId: item.cursoFormacaoId,
            certificateId: item.certificadoId,
            expired: item.expirado,
            status: item.status,
            origin: item.origem
          }) || []),
          hours: data.detalhesHoras?.map(item => ({
            name: item.nomeDoConteudo,
            trained:item.horasTreinadas,
            progress: item.percentualConsumoConteudo,
            type: item.tipo
          }) || []),
          consumedContent: data?.detalhesConteudosConsumidos?.map(item => ({
            userStatus: item.ativo ? 'Ativo' : 'Inativo',
            contentName: item.nomeDoConteudo,
            contentType: item.tipo,
            startedAt: item.dataInicio,
            completedAt: item.dataConclusao,
            status: item.status,
            contentCategory: item.categoria
          }) || []),
          access: data?.acessos?.detalhes?.map(el => ({
            dateAccess: el.dataHoraDoAcesso,
          }))
        },
        consumedContent: {
          total: data?.conteudosConsumidos?.total || 0 as number,
          complete: data?.conteudosConsumidos?.concluido || 0 as number,
          completePercent: data?.conteudosConsumidos?.percentualConcluido || 0 as number,
          onGoing: data?.conteudosConsumidos?.emAndamento || 0 as number,
          onGoingPercent: data?.conteudosConsumidos?.percentualEmAndamento || 0 as number,
        },
        access: {
          accessPerYear: data?.acessos?.acessosPorAno?.map(year => ({
            year: year.ano,
            total: year.total,
            accessPerMonth: year.acessosPorMes.map(month => ({
              month: month.mes,
              total: month.total
            }))
          })),
          total: data?.acessos?.total || 0
        }
      }
    }
  }
}

export default api
